import { ModelBase } from "@shoothill/core";
import { observable, action, runInAction } from "mobx";

export class ProgrammeUpdatesDocumentsModel extends ModelBase<ProgrammeUpdatesDocumentsModel, ProgrammeUpdatesDocumentsDTO> {
    @observable id: string | null = null;
    @observable projectId: string | null = null;
    @observable date: string | null = null;
    @observable programmeUpdatesDate: string | null = null;
    @observable fileName: string = "";
    @observable url: string = "";
    @observable urlInline: string = "";
    @observable isDeleted: boolean = false;
    @observable canDeleteDocument: boolean = true;
    @observable createdByUserId: string | null = null;
    @observable createdDate: string | null = null;
    @observable programmeUpdateDocumentTypeId: string | null = null;

    @action
    reset = () => {
        this.id = null;
        this.projectId = null;
        this.date = null;
        this.programmeUpdatesDate = null;
        this.fileName = "";
        this.url = "";
        this.urlInline = "";
        this.isDeleted = false;
        this.canDeleteDocument = true;
        this.createdByUserId = null;
        this.createdDate = null;
        this.programmeUpdateDocumentTypeId = null;
    };

    @action
    fromDto = (dto: any) => {
        runInAction(() => {
            this.id = dto.id;
            this.projectId = dto.projectId;
            this.date = dto.date;
            this.programmeUpdatesDate = dto.programmeUpdatesDate ?? null;
            this.fileName = dto.fileName;
            this.url = dto.url;
            this.urlInline = dto.urlInline;
            this.isDeleted = dto.isDeleted;
            this.canDeleteDocument = dto.canDeleteDocument ?? true;
            this.createdByUserId = dto.createdByUserId;
            this.createdDate = dto.createdDate;
            this.programmeUpdateDocumentTypeId = dto.programmeUpdateDocumentTypeId ?? null;
        });
    };

    toDto(model: ProgrammeUpdatesDocumentsModel): void {
        throw new Error("Method not implemented.");
    }
}

export interface ProgrammeUpdatesDocumentsDTO {
    id: string | null;
    projectId: string | null;
    date: string | null;
    programmeUpdatesDate: string | null;
    fileName: string;
    url: string;
    urlInline: string;
    isDeleted: boolean;
    createdByUserId: string | null;
    createdDate: string | null;
    programmeUpdateDocumentTypeId?: string | null;
}

export interface ProgrammeUpdatesDocumentTypeDTO {
    id: string | null;
    displayName: string;
    ordinal: number;
    type: ProgrammeUpdatesDocumentTypeEnum;
    isDeleted: boolean;
}

export enum ProgrammeUpdatesDocumentTypeEnum {
    Inspections = 10,
    Permits = 20,
    Scaffolding = 30,
    ToolboxTalk = 40,
    Incidents = 50,
    NonConformance = 60,
    Dilapidation = 70,
    RAMS = 80,
}
